const CoursetabSkeleton = () => {
  return (
    <div className="bg-white rounded-[32px] p-[16px] border border-grey600 shadow-custom-1 md:pl-[24px] md:p-[10px]">
      <div className="flex flex-col items-stretch md:flex-row md:items-center">
        <div className="relative mb-[24px] md:mb-[0] shrink-0">
          <div className="skeleton skeleton-text skeleton-text-animated descript mr-0 w-full md:w-[160px] md:mr-[16px]"></div>
        </div>
        <div className="w-full relative border-y-[1px] border-neutral200 grow md:border-l md:border-y-0">
          <div className="flex items-center my-[12px] md:my-[0]">
            <div className="w-full skeleton skeleton-text skeleton-text-animated descript px-[0] md:mx-[16px]"></div>
          </div>
        </div>
        <div className="w-full relative grow md:border-l border-neutral200">
          <div className="flex items-center my-[12px] md:my-[0]">
            <div className="w-full skeleton skeleton-text skeleton-text-animated descript px-[0] md:mx-[16px]"></div>
          </div>
        </div>
        <div className="pt-[2px] md:pt-[0]">
          <div className="skeleton skeleton_btn skeleton-text-animated w-full  px-[24px] py-[10px] md:min-w-[114px] !my-0"></div>
        </div>
      </div>
    </div>
  );
};

export default CoursetabSkeleton;
